export default __webpack_public_path__ + "ddffe1735c36c3a76d60d11f5063fffc.png";